const AlertService = () => {
	let pub = {};
	
	pub.onAlert = false;
	
	pub.show = (message) => {
		if (!pub.onAlert) {
			console.log("WARNING: No alert callback registered");
			return;
		}
		
		pub.onAlert(message);
	};
	
	return pub;
};

export default AlertService();